import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { map, Observable, of } from 'rxjs';
import { AuthApi, TokenResponse } from '@bo/ng-auth';
import { IntercomToken } from '../../_interfaces/auth.interface';

@Injectable({
  providedIn: 'root',
})
export class AuthApiService extends AuthApi {
  protected override http: HttpClient;
  baseUrl: string = environment.apiRoot;

  URL_LOGIN: string = 'auth/token/';
  URL_LOGOUT: string = '';
  URL_TOKEN_REFRESH: string = 'auth/token/refresh/';
  URL_AUTH_INTERCOM: string = 'auth/intercom';

  constructor() {
    const http = inject(HttpClient);

    super(http);

    this.http = http;
  }

  override logout(): Observable<unknown> {
    return of(null);
  }

  protected serializeRefreshToken(refresh: string): Record<string, string> {
    return { refresh };
  }

  protected serializeLogin(email: string, password: string): Record<string, string> {
    return { username: email, password: password };
  }

  protected deserializeLogin(data: TokenResponse): TokenResponse {
    return data;
  }

  protected deserializeRefreshToken(data: TokenResponse): TokenResponse {
    return data;
  }

  override login(username: string, password: string): Observable<TokenResponse> {
    return super.login(username, password);
  }

  override refreshToken(token: string): Observable<TokenResponse> {
    return this.http
      .post(this.getUrl(this.URL_TOKEN_REFRESH), this.serializeRefreshToken(token))
      .pipe(map((data: TokenResponse) => this.deserializeRefreshToken(data)));
  }

  /**
   * Get Intercom User has token
   *
   * @return Observable<>
   */
  getIntercomToken(): Observable<IntercomToken> {
    return this.http.post<IntercomToken>(this.getUrl(this.URL_AUTH_INTERCOM, true), {});
  }
}
